import { unionBy } from 'lodash';
import EspCRUDActions from '../actions/EspCRUDActions';
import { EspDomainType } from '../model/EspModel';
import {
  retrieved,
  retrievedAll,
  setBusy,
  setUnBusy,
} from './common/commonReducers';

type EspAction = {
  type: string;
  entities?: EspDomainType[];
};

export type EspState = {
  entities: EspDomainType[];
  busy: boolean;
};

const initialState: EspState = {
  entities: [],
  busy: false,
};

function esp(state = initialState, action: EspAction) {
  switch (action.type) {
    case EspCRUDActions.busyAction:
      return setBusy(state);
    case EspCRUDActions.unbusyAction:
      return setUnBusy(state);
    case EspCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case EspCRUDActions.retrievedAction:
      return retrieved(state, action);
    default:
      return state;
  }
}

export default esp;
